import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'

export { default as deepMerge } from 'deepmerge'

export const uuid = () => uuidv4()

// 页面注入js文件
export const injectScript = src => {
  return new Promise((resolve, reject) => {
    const configUrl = src.replace('assets://config/','https://')


    // const xhr = new XMLHttpRequest();
    // xhr.open('GET', src, true);
    // xhr.onreadystatechange = function() {
    //   if (this.readyState === 4 && this.status === 200) {
    //     // eval(xhr.responseText);
    //     console.log('---加载的js文件--->>>',xhr.responseText);
    //   }else{
    //     console.log('---加载的js文件错误--->>>',xhr.responseText,this.status,this.readyState,this);
    //   }
    // };
    // xhr.send();
    

    const script = document.createElement('script')
    script.src = configUrl
    script.onload = resolve
    script.onerror = reject
    document.body.appendChild(script)
  })
}

// 加载资源列表，如果是json，继续遍历加载
export const loaderResources = src => {
  if (typeof src === 'string') return axios.get(src)
  return Promise.all(Object.values(src).filter(src => ('' + src).indexOf('http') ==! -1).map(src => loaderResources(src)))
}


export const supportWebGL = () => {
  if (typeof window === 'object' && typeof document === 'object') {
    const canvasEl = document.createElement('canvas')
    if (canvasEl) {
      const gl = canvasEl?.getContext?.('webgl2')
      return typeof WebAssembly === 'object' && typeof WebAssembly.compile === 'function' && !!gl
    }
  }

  return false
}